(function () {
  'use strict';

  var addInProgress = false;
  var overlayId = 'fp-cart-add-overlay';

  function wait(milliseconds) {
    return new Promise(function (resolve) {
      window.setTimeout(resolve, milliseconds);
    });
  }

  function showOverlay() {
    var overlay = document.getElementById(overlayId);

    if (!overlay) {
      overlay = document.createElement('div');
      overlay.id = overlayId;
      overlay.setAttribute('role', 'status');
      overlay.setAttribute('aria-live', 'polite');
      overlay.innerHTML =
        '<div class="fp-cart-add-overlay__message">' +
          '<span class="fp-cart-add-overlay__spinner" aria-hidden="true"></span>' +
          '<strong>Adding to your cart...</strong>' +
          '<span>Please keep this page open for a moment.</span>' +
        '</div>';
      document.body.appendChild(overlay);
    }

    overlay.style.display = 'flex';
    document.documentElement.classList.add('fp-cart-add-busy');
  }

  function hideOverlay() {
    var overlay = document.getElementById(overlayId);

    if (overlay) {
      overlay.style.display = 'none';
    }

    document.documentElement.classList.remove('fp-cart-add-busy');
  }

  function showError(message) {
    if (window.swal) {
      window.swal({
        title: 'Item not added',
        text: message,
        type: 'error',
        confirmButtonText: 'Try Again'
      });
      return;
    }

    window.alert(message);
  }

  function requestedQuantity(form) {
    var quantityInput = form.querySelector('[name="quantity"]');
    var quantity = quantityInput ? parseInt(quantityInput.value, 10) : 1;
    return isNaN(quantity) || quantity < 1 ? 1 : quantity;
  }

  function cartContainsAddedLine(cart, addedItem, minimumQuantity) {
    if (!cart || !Array.isArray(cart.items) || !addedItem) {
      return false;
    }

    return cart.items.some(function (line) {
      if (addedItem.key && line.key === addedItem.key) {
        return line.quantity >= minimumQuantity;
      }

      return !addedItem.key &&
        String(line.variant_id) === String(addedItem.variant_id || addedItem.id) &&
        line.quantity >= minimumQuantity;
    });
  }

  function responseMessage(responseBody) {
    if (!responseBody) {
      return 'Shopify did not accept this item. Please try Add to Cart again.';
    }

    return responseBody.description ||
      responseBody.message ||
      'Shopify did not accept this item. Please try Add to Cart again.';
  }

  async function fetchFreshCart() {
    var response = await window.fetch('/cart.js?fp_sync=' + Date.now(), {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: {
        Accept: 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error('Unable to verify the cart.');
    }

    return response.json();
  }

  async function verifyAddedLine(addedItem, minimumQuantity) {
    var delays = [0, 150, 400, 800];

    for (var index = 0; index < delays.length; index += 1) {
      if (delays[index]) {
        await wait(delays[index]);
      }

      try {
        var cart = await fetchFreshCart();
        if (cartContainsAddedLine(cart, addedItem, minimumQuantity)) {
          return true;
        }
      } catch (error) {
        // A later verification attempt may succeed after a brief network hiccup.
      }
    }

    return false;
  }

  async function submit(form) {
    if (!form || addInProgress) {
      return false;
    }

    if (!window.fetch || !window.FormData || !window.Promise) {
      form.submit();
      return true;
    }

    addInProgress = true;
    showOverlay();

    var addWasAccepted = false;

    try {
      var quantity = requestedQuantity(form);
      var response = await window.fetch('/cart/add.js', {
        method: 'POST',
        body: new FormData(form),
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json'
        }
      });
      var responseBody = await response.json().catch(function () {
        return null;
      });

      if (!response.ok) {
        throw new Error(responseMessage(responseBody));
      }

      addWasAccepted = true;

      if (!await verifyAddedLine(responseBody, quantity)) {
        throw new Error('Shopify accepted the photos, but the cart could not be verified.');
      }

      window.location.assign('/cart?fp_sync=' + Date.now());
      return true;
    } catch (error) {
      hideOverlay();
      addInProgress = false;

      if (addWasAccepted) {
        // The add response succeeded. A fresh cart is safer than retrying and
        // accidentally duplicating a customer's prints.
        window.location.assign('/cart?fp_sync=' + Date.now());
        return false;
      }

      showError(
        error && error.message
          ? error.message
          : 'We could not confirm this item. Please try Add to Cart again.'
      );
      return false;
    }
  }

  var style = document.createElement('style');
  style.textContent =
    '.fp-cart-add-busy{cursor:wait}' +
    '#fp-cart-add-overlay{position:fixed;inset:0;z-index:2147483647;display:none;' +
      'align-items:center;justify-content:center;padding:24px;background:rgba(255,255,255,.82);' +
      'backdrop-filter:blur(3px);-webkit-backdrop-filter:blur(3px)}' +
    '.fp-cart-add-overlay__message{display:flex;flex-direction:column;align-items:center;' +
      'max-width:360px;padding:24px;text-align:center;color:#252525;background:#fff;' +
      'border:1px solid #dedede;border-radius:6px;box-shadow:0 12px 36px rgba(0,0,0,.16)}' +
    '.fp-cart-add-overlay__message strong{margin-top:12px;font-size:18px}' +
    '.fp-cart-add-overlay__message span:last-child{margin-top:5px;color:#5f6368;font-size:14px}' +
    '.fp-cart-add-overlay__spinner{width:28px;height:28px;border:3px solid #f1d1b2;' +
      'border-top-color:#e8913a;border-radius:50%;animation:fp-cart-add-spin .7s linear infinite}' +
    '@keyframes fp-cart-add-spin{to{transform:rotate(360deg)}}';
  document.head.appendChild(style);

  window.FoxPrintVerifiedCartAdd = {
    submit: submit
  };
}());
